import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  otterService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface OtterPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function OtterPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: OtterPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="otter"
      displayName="Otter.ai"
      description="Connect your Otter.ai account to access your meeting transcripts, summaries, and action items directly in conversations."
      features={[
        'Search your past Otter conversations',
        'Pull up transcripts from past meetings',
        'Surface action items and key decisions',
        'AI-powered meeting summaries',
      ]}
      accentColor="sky"
      events={{
        modalOpened: OnboardingEvents.OTTER_MODAL_OPENED,
        oauthStarted: OnboardingEvents.OTTER_OAUTH_STARTED,
        connected: OnboardingEvents.OTTER_CONNECTED,
        connectionFailed: OnboardingEvents.OTTER_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.OTTER_MODAL_CLOSED,
      }}
      service={otterService}
    />
  );
}
